import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const adminCommercialistiApi = createApi({
  reducerPath: "adminCommercialisti",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["commercialisti"],
  endpoints: (builder) => ({
    getCommercialista: builder.query({
      query: ({
        page: { startRow, endRow },
        value = "",
        filter = { studioId: "", identityRoleId: "" },
      }) => ({
        url: `admin/Commercialista/list?query=${value.toLowerCase()}&studioId=${filter?.studioId
          }&identityRoleId=${filter?.identityRoleId}`,
        method: "POST",
        headers: headersType(),
        body: { startRow, endRow },
      }),
      providesTags: ["commercialisti"],
    }),
    getCommercialistaId: builder.query({
      query: (id) => ({
        url: "/admin/commercialista/" + id,
        method: "GET",
        headers: headersBase()
      }),
      providesTags: ["commercialista"],
    }),
    createCommercialista: builder.mutation({
      query: (userData) => ({
        url: `admin/Commercialista`,
        method: "POST",
        headers: headersType(),
        body: userData,
      }),
      invalidatesTags: ["commercialisti"],
    }),
    // createCommercialistaAdmin: builder.mutation({
    //   query: (userData) => ({
    //     url: `/admin/commercialista/createwithstudio`,
    //     method: "POST",
    //     headers: headersType(),
    //     body: userData,
    //   }),
    //   invalidatesTags: ["commercialisti"],
    // }),
    associaUser: builder.mutation({
      query: (user) => ({
        url: `/admin/commercialista/associateuser`,
        method: "POST",
        headers: headersType(),
        body: user,
      }),
      invalidatesTags: ["commercialista"],
    }),
    dissociaUser: builder.mutation({
      query: (user) => ({
        url: "/admin/commercialista/disassociateuser",
        method: "POST",
        headers: headersType(),
        body: user,
      }),
      invalidatesTags: ["commercialista"],
    }),
    deleteCommercialista: builder.mutation({
      query: (operatorId) => ({
        url: `/admin/commercialista/${operatorId}`,
        method: "DELETE",
        headers: headersBase()
      }),
      invalidatesTags: ["commercialisti"],
    }),
    saveCommercialista: builder.mutation({
      query: (data) => ({
        url: `/admin/Commercialista/${data.id}`,
        method: "PUT",
        headers: headersType(),
        body: data,
      }),
      invalidatesTags: ["commercialisti", "commercialista"],
    }),
  }),
});

export const {
  useGetCommercialistaQuery,
  useGetCommercialistaIdQuery,
  useCreateCommercialistaMutation,
  // useCreateCommercialistaAdminMutation,
  useAssociaUserMutation,
  useDeleteCommercialistaMutation,
  useSaveCommercialistaMutation,
  useDissociaUserMutation,
} = adminCommercialistiApi;
